import { Injectable } from '@angular/core';
import { Http, Headers, Request, RequestOptions, RequestMethod, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { api } from './api';
import { UserAuthService } from './user-auth.service';

@Injectable()
export class UsersService {

	private usersUrl: string = api.base + '/list-users?per-page=0';

	constructor(
		private http: Http,
		private userAuthService: UserAuthService
	) { }

	private getRequestOptions( options ) {
		let headers = new Headers();
		headers.append( 'Accept', 'application/json' );
		headers.append( 'Authorization', 'Bearer ' + this.userAuthService.getToken() );
		options.headers = headers;
		let requestOptions = new RequestOptions(options);
		return requestOptions;
	}

	private handleError(error: Response | any) {
		return Observable.throw(error);
	}

	getUser(id: number) {

		let requestOptions = {
			withCredentials: true,
			method: RequestMethod.Get,
			url: this.usersUrl + '/' + id,
		}

		let user$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return user$;

	}

	getUsers() {

		let requestOptions = {
			withCredentials: true,
			method: RequestMethod.Get,
			url: this.usersUrl,
		}

		let users$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return users$;

	}

	clientUserCouple( clientID: number, userID: number ) {

		let coupleUrl: string = api.base + '/user-has-customers';

		var info: {} = {
			customer_id: clientID,
			user_id: userID,
		}

		let requestOptions = {
			withCredentials: true,
			method: RequestMethod.Post,
			url: coupleUrl,
			body: info,
		}

		let coupling$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return coupling$;

	}

	clientUserEditRelation( couplingID: number, endedBy: number ) {

		let decoupleUrl: string = api.base + '/user-has-customers/' + couplingID;

		var info: {} = {
			ended_by: 1,
		}

		let requestOptions = {
			withCredentials: true,
			method: RequestMethod.Put,
			url: decoupleUrl,
			body: info,
		}

		let coupling$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return coupling$;

	}

}



// WEBPACK FOOTER //
// ./src/app/users.service.ts